import templateUrl from "emun.order/backorders/backorder-lines-prompt.htm";
import BackorderLinesPromptController from "emun.order/backorders/backorder-lines-prompt.controller";
import open from "webmodals/open";

let BackorderLinesPrompt = options => {
	let modalInstance = open({
		size: options.size || "md",
		templateUrl: options.templateUrl || templateUrl,
		controller: BackorderLinesPromptController,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			options: () => options
		}
	});

	return modalInstance.result;
};

export default BackorderLinesPrompt;
